export const flattenNodes = <N extends { nodes: N[] }>({
    nodes,
    getChildren,
}: {
    nodes: N[]
    getChildren: (node: N) => N[]
}): N[] => {
    const result: N[] = []
    const traverse = (nodeList: N[]) => {
        for (const node of nodeList) {
            result.push({ ...node, nodes: [] }) // Push the node without its children
            const children = getChildren(node)
            if (children.length > 0) {
                traverse(children) // Recursively traverse the child nodes
            }
        }
    }

    traverse(nodes)
    return result
}
